import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchSubscribers = createAsyncThunk(
  'newsletter/fetchSubscribers',
  async (params: { page?: number; limit: number; email?: string }, { rejectWithValue }) => {
    try {
      const response = await api.get('/newsletter/subscription', { params });      
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || { message: 'An unexpected error occurred' });
    }
  }
);
